// extracted by mini-css-extract-plugin
module.exports = {"text":"InviteFriendsModal_text__2g9yH"};